import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Radio, Users, Circle } from 'lucide-react';
import { api, mediaUrl } from '@/lib/api';

export const LiveNowCarousel = () => {
    const [lives, setLives] = useState([]);
    useEffect(() => {
        let m = true;
        api.get('/livestreams/active').then(({ data }) => { if (m) setLives(data || []); }).catch(() => {});
        return () => { m = false; };
    }, []);
    if (!lives.length) return null;
    return (
        <section className="my-6" data-testid="live-now-carousel">
            <div className="flex items-center gap-2 mb-3">
                <Radio className="h-5 w-5 text-red-600 animate-pulse" />
                <h2 className="text-xl font-semibold tracking-tight">En vivo ahora</h2>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {lives.map(l => {
                    const cover = l.cover_url || l.products_preview?.[0]?.media?.[0]?.url;
                    return (
                        <Link key={l.id} to={`/live/${l.id}`} className="group block rounded-2xl overflow-hidden bg-card border shadow-[var(--ok-shadow-sm)] hover:shadow-[var(--ok-shadow-card)]" data-testid={`live-card-${l.id}`}>
                            <div className="relative aspect-video bg-neutral-900 overflow-hidden">
                                {/* Animated live preview: uses looping muted video sample as mock while Agora is mock */}
                                <video
                                    src="https://cdn.pixabay.com/video/2020/03/24/34120-401346577_tiny.mp4"
                                    poster={cover ? mediaUrl(cover) : undefined}
                                    className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
                                    autoPlay muted loop playsInline
                                />
                                {cover && <img src={mediaUrl(cover)} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30 mix-blend-multiply pointer-events-none" />}
                                <div className="absolute top-2 left-2 flex items-center gap-1 bg-red-600 text-white text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wide"><Circle className="h-1.5 w-1.5 fill-white animate-pulse" />En vivo</div>
                                <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 text-white text-[10px] px-2 py-1 rounded-full"><Users className="h-3 w-3" />{l.current_viewers || 0}</div>
                            </div>
                            <div className="p-3">
                                <div className="line-clamp-2 text-sm font-medium">{l.title}</div>
                                <div className="text-xs text-muted-foreground mt-1">@{l.seller_nickname}</div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
};
